import { SelectField, SelectFieldOption } from "@funcional/react-ui";
import { Grid } from "@material-ui/core";
import { DeepMap, FieldError, FieldValues } from "react-hook-form";

export function DropDownList({
    label, 
    options, 
    item, 
    readonly, 
    control, 
    errors, 
    defaultValue,
    register,
    index,
}: {
    label?: string, 
    options: any[], 
    item: string, 
    readonly: boolean, 
    control?: any, 
    errors: DeepMap<FieldValues, FieldError>, 
    defaultValue: any,
    register?: any,
    index?: number
}) {
    
    const invalidValue = defaultValue === "-" ? true : false;
    const validOptions = item === "industryName" ? [] : options?.filter((option) => option.value !== defaultValue);
    const cursor = readonly ? "not-allowed" : "default";
    const defaultValueView = options?.find((option) => defaultValue && option.value === defaultValue);
    
    return (
        <Grid item xs={6} md={6}>
            <SelectField
            key={index}
            required
            name={item}
            control={control}
            disabled = {readonly}
            style={{width: "300px", cursor}}
            errorMessage={errors ? errors[item]?.message : null}
            label={label}
            {...register ? {...register(
             `exceptions.${index}.${item}` as `exceptions.0.${typeof item}`
            )} : {}}>
                <SelectFieldOption disabled={invalidValue} selected={invalidValue} hidden={invalidValue} 
                value={defaultValue ? defaultValue : "-"}>{defaultValue ? defaultValueView?.view: "-"}</SelectFieldOption>
                {(validOptions)?.map((option, index) => {
                    return (<SelectFieldOption key = {index} value={option.value}>{option.view}</SelectFieldOption>)
                })}
            </SelectField>
        </Grid>
    )
}